<style>
	 @import '@/assets/css/custom.css';
</style>

<template>
   <div>
       <Breadcrumbs main="Category Attributes" title="Manage Category Attributes" />

      <div class="container-fluid">
         <div class="row">
            <div class="col-sm-12">
               <div class="card">
                  <div class="card-body">

                     <div class="col-md-12 project-list  page-subtitle">
                        <div class="row">
                           <div class="col-md-10 d-flex">
                              <span style="font-size: 20px; font-weight: bolder;">Manage Category Attributes</span>
                           </div>
                           <!-- <div class="col-md-2 d-flex">
                              <a href="#" @click.prevent="$router.go(-1)" class="btn btn-primary float-end"><i class='fa fa-chevron-left'></i> Back</a>
                           </div> -->
                           <div class="col-md-2">
                              <!-- <router-link :to="{ name: 'addattribute' }" class="btn btn-primary">Add Attribute</router-link> -->
                              <button class="btn btn-primary" type="button" data-original-title="test" @click="openModal">Add Attribute</button>
                              <!-- <div class="btn btn-primary">Add Attribute</div> -->
                           </div>                           
                        </div>
                     </div>

                     <div class="col-md-12 project-list  filter-sort">
                        <div class="row">
                           <div class="col-md-9 d-flex">
                              <label class="d-flex listing-length"><span>Show</span>
                                 <select class="form-select"  v-model="listing_length" @change="fetchAttributes()">
                                    <option value="5">5</option>
                                    <option value="10">10</option>
                                    <option value="20">20</option>
                                 </select>
                                   <span>entries</span>
                              </label>
                           </div>
                              
                           <div class="col-md-3">
                                 <input type="text" class="form-control" placeholder="Search" v-model="keyword" @keyup="fetchAttributes()"/>
                           </div>
                        </div>
                     </div>

                     <div class="table-responsive product-table">
                        <table class="display" id="basic-1">
                           <thead>
                              <tr>
                                 <th class="sorting_asc" tabindex="0" aria-controls="basic-1" rowspan="1" colspan="1"
                                    aria-sort="ascending" aria-label="Name: activate to sort column descending"
                                    style="width: 415.266px;">Name</th>
                                 <th class="sorting" tabindex="0" aria-controls="basic-1" rowspan="1" colspan="1"
                                    aria-label="Type: activate to sort column ascending"
                                    style="width: 337.797px;">Type</th>
                                 <th class="sorting" tabindex="0" aria-controls="basic-1" rowspan="1" colspan="1"
                                    aria-label="Status: activate to sort column ascending"
                                    style="width: 337.797px;">Status</th>
                                 <th class="sorting" tabindex="0" aria-controls="basic-1" rowspan="1" colspan="1"
                                    aria-label="Options: activate to sort column ascending"
                                    style="width: 415.266px;">Options</th>	
                              </tr>
                           </thead>
                           <tbody v-for="catAttribute in catAttributes" :key="catAttribute.id">
                              <tr v-for="attributes in catAttribute.attribute" :key="attributes.id">
                              <!-- <tbody>
                                 <tr> -->
                                 <td>{{attributes.name}}</td>
                                 <td>
                                    <label v-if="attributes.type==1">radio</label>
                                    <label v-if="attributes.type==2">checkbox</label>
                                    <label v-if="attributes.type==3">text</label>
                                    <label v-if="attributes.type==4">textarea</label>
                                    <label v-if="attributes.type==5">grid</label>
                                </td>
                                 <td>
                                    <label v-if="attributes.status==1">Active</label>
                                    <label v-else>Blocked</label>
                                 </td>
                                 <td>                                   
                                    <a class="btn btn-danger btn-sm mt-2 me-1" @click="deleteAttribute(catAttribute.id)">Delete</a>

                                    <router-link :to="{name: 'attributes.show', params: { id: attributes.id }}" class="btn btn-sm btn-primary mt-2 me-1" >Values</router-link>             
                                 </td>
                              </tr>
                           </tbody>
                        </table>
                     </div>

                     <!----pagination starts --->
                     <nav aria-label="Page navigation" class="mt-2">                    
                        <ul class="pagination">
                           <li class="page-item" v-bind:class="[{disabled: !page.url}, {active: page.active}]" v-for="(page, index) in pagination" :key="page.label">
                              <a class="page-link" href="#" @click.prevent="fetchAttributes(page.url + '&limit='+ listing_length + '&keyword=' + keyword )" tabindex="-1">
                                 <span v-if="index == 0">Prev</span>
                                 <span v-else-if="index == pagination.length-1">Next</span>
                                 <span v-else>{{page.label}}</span>
                              </a>
                           </li>                        
                        </ul>
                     </nav>
                     <!----pagination ends --->

                  </div>
               </div>
            </div>
         </div>
      </div>

      <DynamicModal title="Add Attribute">
			<template #body>
				<form @submit.prevent="addAttribute" enctype="multipart/form-data">
					<div class="col-md-12 form-group mt-2">
						<label class="control-label">Attribute <span class="required">*</span></label>
						<select class="form-control" v-model="attribute_id" v-bind:class="{ 'is-invalid': Boolean(errors.attribute_id) }">
							<option :value="null" disabled>-- Select Type --</option>
							<option v-for="attributes in attributeValues" :key="attributes.id" :value="attributes.id">{{ attributes.name }}</option>
						</select>
						<div v-for="(val, index) in errors.attribute_id" :key="index" class="invalid-feedback">
							<p class="mb-0">{{ val }}</p>
						</div>
					</div>

					<div class="col-md-12 form-group mt-2">
						<button type="submit" class="btn btn-primary me-3" >Add</button>
						<button class="btn btn-light" @click="closeModal()">Close</button>
					</div>
				</form>
			</template>
		</DynamicModal>


     
  </div>
</template>


<script>
import { onMounted } from 'vue'
import {Modal} from "bootstrap"
import DynamicModal from '@/components/dynamic_modal.vue'
   let dynamicmodal;

export default {
   name:'ViewAttributes',

   components: {
			DynamicModal
		},
		setup(){
			onMounted(() => {
				dynamicmodal = new Modal(document.getElementById('dynamicmodal'));
			})

			const showModal = () => {
				dynamicmodal.show();
			}

			const hideModal = () => {
				dynamicmodal.hide();
			}

			return {
				showModal, hideModal
			}
		},

   data() {
      return {
         catAttributes: [], 
         categories: [],        
         attributeValues: [],
         pagination: {},
         edit: false,
         id: null,
         attribute_id: '',
         category_id:'',
         keyword: '',
         listing_length: 10,
         token: '',
         errors: {},
         activate: false,
         deactivate: false,
         active_page_url: null,
      };
   },
   mounted () {
      
   },

   created() {
      this.fetchCatAttributes();
      this.fetchAttributes();
   },

   methods: {      

         fetchCatAttributes(page_url=null) {
               let url = '/api/admin/category_attributes?category_type_id=' + this.$route.params.id + '&category_id=' + this.$route.params.cat_id;
               page_url = page_url || url;   

               this.active_page_url = page_url;     
                  
               this.getToken();
               this.$axios
                  .get(page_url,{headers: {Authorization: 'Bearer ' + this.token,}})
                  .then(res => {
                  var responseData = res.data.data;
                  this.catAttributes = responseData;  
                  console.log(responseData);
                  console.log(this.catAttributes);
                  this.pagination = responseData.links
                  
                  })
                  .catch(err => console.log(err));
         },    

         fetchAttributes() {
				this.getToken();
				this.$axios
					.get('/api/admin/attributeValues?category_type_id=' + this.$route.params.id, {
                  headers: {
                     Authorization: 'Bearer ' + this.token
                  }
               })
					.then((res) => {
						var responseData = res.data;
						this.attributeValues = responseData.data;
						console.log(this.attributeValues);
					})
					.catch((err) => console.log(err));
			},

         openModal() {
				this.showModal();
			},

			closeModal() {
				this.hideModal();
			},

         getToken() {
         if (localStorage.getItem('slo_admin')) {
            var slo_admin =  JSON.parse(localStorage.getItem('slo_admin')); 
                    
            if(slo_admin.token) {
               this.token = slo_admin.token;
               this.user = slo_admin;

            } else {
               this.$swal("", "Failed to fetch token, please login again", "error");
               this.$router.push({ name: "Login" });
            }

         } else {
            this.$swal("", "Session expired, please login again", "error");
            this.$router.push({ name: "Login" });
         }
      },

         addAttribute() {
				this.getToken();
				let formData = new FormData();
				formData.append("cat_type_id", this.$route.params.id);
				formData.append("cat_id", this.$route.params.cat_id);
            formData.append("attribute_id", this.attribute_id);
				const config = {
					headers: {
						"content-type": "multipart/form-data",
						Authorization: "Bearer " + this.token,
					},
				};
				let url;
				
				url = "/api/admin/category_attributes/add";
				this.active_page_url = null;
				this.$axios
					.post(url, formData, config)
					.then((response) => {
						if (response.data.status) {
							this.$swal("", response.data.message, "success");
						} else {
							this.$swal("", response.data.message, "error");
						}
						this.clearForm();
						this.closeModal();
						this.fetchCatAttributes(this.active_page_url);
					})
					.catch((error) => {
						console.log(error.response.data);

						if (error.response) {
							if (error.response.data.message) {
								this.errors = error.response.data.message;
								this.$swal("", error.response.data.message, "error");
							} else {
								this.$swal("", "Something went wrong", "error");
							}
						} else {
							this.$swal("", "Something went wrong", "error");
						}
					});
			},

         clearForm() {
				this.attribute_id = "";
            this.cat_type_id = "";
            this.cat_id = "";
            this.id = null;
				this.errors = {};
			},

         deleteAttribute(id) {
            this.delete = false;
            this.$swal({
               icon: 'warning',
               title:"Confirm",
               text:'Are you sure you want to delete this category attribute?',
               showCancelButton: true,
               confirmButtonText: 'Yes',
               confirmButtonColor: '#e64942',
               cancelButtonText: 'No',
               position: "center",
               showConfirmButton: true,
               timer: '',
               toast: false,
               cancelButtonColor: '#efefef',
            }).then((result)=>{
               // this.delete = value
               if(result.value){
                  this.getToken();
                  let formData = new FormData();
				      formData.append("category_attribute_id", id);
                  const config = {
                     headers: {
                        "content-type": "multipart/form-data",
                        Authorization: "Bearer " + this.token,
                     },
                  };
                  let url;
                  console.log(id);
                  url = "/api/admin/DeleteCategoryAttributes";
                  this.active_page_url = null;
                                 
                  this.$axios
                  .post(url, formData, config)
                  .then(response => {
                     if(response.data.status) {
                        this.$swal("", response.data.message, "success");
                     } else {
                        this.$swal("", response.data.message, "error");
                     }
                        this.fetchCatAttributes();
                  })
                     .catch(err => console.log(err));
               }
            })   
         },
        
   }   
}
</script>